import { useNavigation } from '../navigation-context'
import { PrimaryLeftNavigation } from './components/primary-left-navigation'
import { SecondaryLeftNavigation } from './components/secondary-left-navigation'

export function LeftNavigation() {
  const { navigationVariant } = useNavigation()

  return navigationVariant === 'secondary' ? (
    <SecondaryLeftNavigation />
  ) : (
    <PrimaryLeftNavigation />
  )
}
